// src/components/BackToTop.jsx
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence, useScroll } from 'framer-motion';
import { FaArrowUp } from 'react-icons/fa';
import { useLang } from '../context/LangContext';

// Circle circumference for r=22: 2π×22 ≈ 138.23
const CIRCUMFERENCE = 138.23;

const BackToTop = () => {
  const { isRtl } = useLang();
  const [isVisible, setIsVisible] = useState(false);
  const { scrollYProgress } = useScroll();

  useEffect(() => {
    const unsub = scrollYProgress.onChange(v => setIsVisible(v > 0.1));
    return () => unsub();
  }, [scrollYProgress]);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          style={{
            position: 'fixed',
            bottom  : '110px',
            [isRtl ? 'right' : 'left']: '28px',
            zIndex  : 9998,
          }}
        >
          <motion.button
            onClick={scrollToTop}
            whileHover={{ y: -4, boxShadow: '0 10px 22px rgba(0,0,0,0.35)' }}
            whileTap={{ scale: 0.9 }}
            aria-label="Back to top"
            style={{
              width          : '52px',
              height         : '52px',
              borderRadius   : '50%',
              background     : '#8B3A3A',
              border         : 'none',
              cursor         : 'pointer',
              display        : 'flex',
              alignItems     : 'center',
              justifyContent : 'center',
              color          : '#fff',
              position       : 'relative',
            }}
          >
            {/* Progress ring */}
            <svg
              width="52"
              height="52"
              style={{ position: 'absolute', top: 0, left: 0, transform: 'rotate(-90deg)' }}
              aria-hidden
            >
              <motion.circle
                cx="26" cy="26" r="22"
                stroke="#D4AF37"
                strokeWidth="3"
                fill="transparent"
                strokeLinecap="round"
                strokeDasharray={CIRCUMFERENCE}
                style={{ strokeDashoffset: scrollYProgress.get() === 0 ? CIRCUMFERENCE : undefined }}
                strokeDashoffset={0}
                pathLength={scrollYProgress}
              />
            </svg>

            <FaArrowUp size={17} />
          </motion.button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default BackToTop;
